import * as React from 'react'
import styled, { sProp } from '../../../theme/styled'

type TabViewProps = {
  title?: string | null
}

const TabViewWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

const tabProp = sProp(['workspace', 'tabs'])

const TabViewHeader = styled.div`
  height: ${tabProp('height')};
  background: ${tabProp('tabBarBg')};
  margin: 0;
`

const Tab = styled.div`
  font-size: ${({ theme }) => theme.fonts.smallSize};
  width: 200px;
  background: ${tabProp('background')};
  color: ${tabProp('color')};
  height: ${tabProp('height')};
  line-height: ${tabProp('height')};
  padding: 0 20px;
  position: relative;

  img {
    position: absolute;
    width: 18px;
    height: 18px;
    right: 8px;
    top: 7px;
  }
`

const CloseIcon = require('./close.svg')

class TabView extends React.Component<TabViewProps> {
  render() {
    return (
      <TabViewWrapper>
        <TabViewHeader>
          {this.props.title && (
            <Tab>
              {this.props.title || 'Untitled*'}{' '}
              <img src={CloseIcon} alt="close" />
            </Tab>
          )}
        </TabViewHeader>
        {this.props.children}
      </TabViewWrapper>
    )
  }
}

export default TabView



// WEBPACK FOOTER //
// ./src/Components/Shared/TabView/index.tsx